import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import footerStyles from './footer.module.scss';
import twitter from "../images/twitter.png";
import applePodcast from "../images/podcastListen.svg";
import googlePodcast from "../images/google1x.png";
import youtube from "../images/youtube.png";

const Footer = () => {
    const data = useStaticQuery(graphql`
        query {
            site{
                siteMetadata {
                    author
                }
            }
        }
    `)
    return (

        <footer className={footerStyles.footer}>
            
             <div className={footerStyles.title}>
                <h1> Paperbacker Podcast </h1> 
             </div>      
             <div className={footerStyles.footerNav}>
                <h3>Site</h3>
                <Link to="/"> Home </Link> <br/>
                <Link to="/about"> About </Link> <br/>
                <Link to="/podcast"> Podcast </Link> <br />
                <Link to="/blog"> Blog </Link><br />
                <Link to="/contact"> Contact </Link> <br/>
                <Link to="/subscribe">Subscribe</Link>
            </div>    
            <div className={footerStyles.socialContainer}>
                    <p>Follow the Show: </p>
                    <a href="https://twitter.com/PaperbackerP" rel="noopener noreferrer" target="_blank" > <img src={twitter} alt="Twitter" style={{width:'50px'}}/> Twitter  </a>
                    <a href="https://podcasts.apple.com/us/podcast/paperbacker-podcast/id1525049343" target="_blank" rel="noopener noreferrer"><img src={applePodcast} alt="apple podcast" /></a>
                    <a href="https://www.google.com/podcasts?feed=aHR0cHM6Ly9wYXBlcmJhY2tlci5uZXRsaWZ5LmFwcC9yc3MueG1s" rel="noopener noreferrer" target="_blank"><img src={googlePodcast} alt="google podcasts" /></a>
                    <a href="https://www.youtube.com/channel/UCo-uS6RQ5H4dxhpDP2Mj1lw" rel="noopener noreferrer" target="_blank"><img src={youtube} alt="Youtube" style={{width:'140px'}}/></a>
            </div>
            
            <div className={footerStyles.break}></div>
            <p>  created by: {data.site.siteMetadata.author} &copy; 2020</p>
            
        </footer>
    )
}

export default Footer;